/* eslint-disable no-nested-ternary */
import { Fragment } from 'react'
import { STATUS_DETAIL } from '../../academy/urls'
import { useMessage } from '../../core/hooks/message'
import { checkPermission as cp } from '../../users/utils/auth'
import { useModal } from '../../core/hooks/modal'
import ColumnUpdate from './ColumnUpdate'
import Loader from '../../core/components/Loader'
import { StatusType } from '../../academy/types'
import { useStatuDelete } from '../../academy/hooks/status'

export type Props = {
    status: StatusType
    columns?: StatusType[]
    onDelete: () => void
    onUpdate: () => void
    changePosition: (status: StatusType, direction: number) => void
}

export default function ColumnItem({ status, changePosition, onDelete, columns, onUpdate }: Props) {
    const deleteStatus = useStatuDelete()

    const [showMessage] = useMessage()
    async function deleteColumn() {
        if (global.confirm('Вы действительно хотите удалить?')) {
            const { error } = await deleteStatus.mutate({ url: STATUS_DETAIL.replace('{id}', String(status.id)) })

            if (error) {
                showMessage(error.data.detail, 'is-danger')
                return
            }
            onDelete()
        }
    }

    const [showUpdateModal, hideUpdateModal] = useModal(
        <ColumnUpdate status={status} onSuccess={async () => {
            await onUpdate()
            hideUpdateModal()
        }} onCancel={() => {
            hideUpdateModal()
        }} />,
    )

    return (
        <tr>
            <td>
                <span style={{ color: status.color }}>
                    {status.title}
                </span>

                <span className="has-text-grey-light">
                    {status.type !== 'intermediate' ? ' (системный)' : null}
                </span>
            </td>

            <td>
                <div className="is-pulled-right">
                    { status.position <= (columns?.length || 0) - 2
                        && cp('academy.change_status')
                        && status.type === 'intermediate' ? (
                            <i onClick={() => changePosition(status, 1)} className="icon ion-md-arrow-down pointer" />
                        ) : null }

                    { status.position > 2 && cp('academy.change_status') && status.type === 'intermediate' ? (
                        <i onClick={() => changePosition(status, -1)} className="icon ion-md-arrow-up pointer" />
                    ) : null}

                    { status.type === 'intermediate' && cp('academy.change_status') ? (
                        <Fragment>
                            &nbsp; &nbsp; &nbsp;
                            {cp('academy.delete_status') ? (
                                !deleteStatus.isLoading ? (
                                    <i onClick={deleteColumn} className="icon pointer ion-md-trash" />
                                ) : <Loader className="icon" />
                            ) : null}

                            {cp('academy.change_status') ? (
                                <i onClick={showUpdateModal} className="icon pointer ion-md-create" />
                            ) : null}
                        </Fragment>
                    ) : null}
                </div>
            </td>
        </tr>
    )
}
